import { apiClient } from './apiClient';

/**
 * User service for API operations
 */
export class UserService {
    constructor() {
        this.BASE_URL = '/users';
    }



    async getAllInternalUsersREST(orgId) {
        return apiClient.get(`${this.BASE_URL}/internal/all`, {
            data: { orgId }
        });
    }


       /**
         * Check if user has specific permission(s) via backend
         * @param {string | string[]} permissions - Permission(s) to check
         * @param {boolean} requireAll - Whether all permissions are required (default: true)
         * @returns {Promise<{hasAccess: boolean}>}
         */
        async checkPermission(permissions, requireAll = true) {
            try {
                const response = await apiClient.post(`${this.BASE_URL}/permissions/check`, {
                    permissions: Array.isArray(permissions) ? permissions : [permissions],
                    requireAll
                });
                return response // { hasAccess: boolean }
            } catch (error) {
                console.error('Permission check failed:', error);
                throw error;
            }
        }
    
        /**
         * Get user's permissions from backend
         * @returns {Promise<{permissions: string[]}>}
         */
    async getUserPermissions() {
            try {
                const response = await apiClient.get(`${this.BASE_URL}/permissions`);
                return response 
            } catch (error) {
                console.error('Failed to fetch user permissions:', error);
                throw error;
        }
    }

    async getClaimSavedFilters(userId) {
        if (!userId) {
            throw new Error('userId is required to fetch saved claim filters');
        }
        return apiClient.get(`${this.BASE_URL}/${userId}/preferences/claim-filters`);
    }

    async saveClaimSavedFilters(userId, savedFilters = []) {
        if (!userId) {
            throw new Error('userId is required to save claim filters');
        }
        return apiClient.put(`${this.BASE_URL}/${userId}/preferences/claim-filters`, {
            savedFilters
        });
    }

    async updateSmsNotificationPreference(userId, enabled) {
        if (!userId) {
            throw new Error('userId is required to update SMS notification preferences');
        }
        return apiClient.put(`${this.BASE_URL}/${userId}/preferences/sms-notifications`, {
            enabled
        });
    }

    async updateScannerProductKey(userId, productKey) {
        if (!userId) {
            throw new Error('userId is required to update scanner product key');
        }
        return apiClient.put(`${this.BASE_URL}/${userId}/preferences/scanner-product-key`, {
            productKey
        });
    }

    async updateViewModePreference(userId, viewMode) {
        if (!userId) throw new Error('userId is required to update view mode');
        return apiClient.put(`${this.BASE_URL}/${userId}/preferences/view-mode`, { viewMode });
    }
}

// Create a singleton instance
export const userService = new UserService();
